import { Component, OnInit } from "@angular/core";
import { HttpService } from "../../http.service";
import { GlobalService } from "../../global.service";
import { MatDialog, ProgressSpinnerMode, ThemePalette } from "@angular/material";
import { NewPurchaseCompanyComponent } from "../new-purchase-company/new-purchase-company.component";

@Component({
  selector: "app-input-stock-entry-with-grn",
  templateUrl: "./input-stock-entry-with-grn.component.html",
  styleUrls: ["./input-stock-entry-with-grn.component.scss"],
})
export class InputStockEntryWithGrnComponent implements OnInit {
  title = "";
  grn_number = null;
  by_product_group_list = [];
  by_product_dict = {};
  selected_product_list = [];
  bill_number = '';
  po_number = null;
  po_date = null;
  dc_number = null;
  dc_date = null;
  bill_date = null;
  source = null;
  show_grn_table = false;
  show_product_goods_table = false;
  product_goods_record = []
  selected_product_name = null;
  // grn_date: any = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0];
  grn_date: any = new Date(new Date()).toISOString().split('T')[0];
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  purchase_company_list = null;

  is_previous_sale_closed = true;
  is_today_sale_closed = false;
  previous_date = null;
  today_date_from_server = null;
  today_sale_close_details = null;

  constructor(
    private httpService: HttpService,
    private globalService: GlobalService,
    public dialog: MatDialog
  ) {
    this.title = this.globalService._active_display_name;

    this.serveProductList();
    this.servePurchaseCompany();
  }

  saleClosedCalled(date = Date) {
    if (confirm('Are you sure want to close the sale')) {
      let data_dict = {
        'date': date
      }
      this.httpService.closeSale(data_dict).subscribe((data) => {
        console.log(data);
        this.serveDailyCloseStatus();
      }, (error) => {
        console.error(error);
      });
    }
  }

  serveDailyCloseStatus() {
    this.httpService.serveDailyCloseStatus().subscribe((data) => {
      console.log(data);
      this.is_previous_sale_closed = data['is_previous_sale_closed'];
      this.is_today_sale_closed = data['is_today_sale_closed'];
      this.previous_date = data['previous_date'];
      this.today_date_from_server = data['today_date'];
      this.today_sale_close_details = data['today_sale_close_details'];
    }, (error) => {
      console.error(error);
    });
  }


  servePurchaseCompany() {
    this.httpService.servePurchaseCompany().subscribe((data) => {
      console.log(data);
      this.purchase_company_list = data;
    }, (error) => {
      console.error(error);
    });
  }

  newPurchaseCompany() {
    const dialogRef = this.dialog.open(NewPurchaseCompanyComponent, {
      height: '550px',
      width: '600px',
      data: {
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        this.source = null;
        this.servePurchaseCompany();
      }
    });
  }

  serveProductList() {
    this.is_data_available = false;
    this.httpService.serveInputStock().subscribe(
      (data) => {
        console.log(data);
        this.by_product_group_list = data["by_product_group_list"];
        this.by_product_dict = data["by_product_dict"];
        this.is_data_available = true;
      },
      (error) => {
        this.is_data_available = true;
        console.error(error);
      }
    );
  }

  serveGrnNumber() {
    this.httpService.serveGoodsGRNNumber().subscribe(
      (data) => {
        console.log(data);
        this.grn_number = data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  enableGrn() {
    this.show_grn_table = !this.show_grn_table;
    if (!this.show_grn_table) {
      console.log('back')
      this.checkAndBackToOldGrnNumber();
      this.grn_number = null;
      this.bill_number = null;
      this.grn_date = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0];
      this.po_date = null;
      this.bill_date = null;
      this.po_number = null;
      this.dc_date = null;
      this.dc_number = null;
      this.source = null;
      this.selected_product_list = [];
    } else {
      this.serveDailyCloseStatus();
    }
  }

  checkboxChanged(event, product_dict) {
    console.log("event called");
    console.log(product_dict)
    if (event.checked) {
      this.selected_product_list.push(product_dict);
    } else {
      let product_group_id = product_dict["product_group"];
      let product_list = this.by_product_dict[product_group_id];
      let main_product_index = product_list
        .map((element) => {
          return element.id;
        })
        .indexOf(product_dict['id']);
      let product_index = this.selected_product_list
        .map((element) => {
          return element.id;
        })
        .indexOf(product_dict["id"]);
      this.selected_product_list.splice(product_index, 1);
      this.resetValue(product_group_id, main_product_index);
    }
  }

  addNewAndOldQty(product_index) {
    let old_qty = this.selected_product_list[product_index]["quantity_now"];
    let new_qty = this.selected_product_list[product_index]["new_quantity"];
    if (new_qty == null) {
      new_qty = 0;
    }
    return old_qty + new_qty;
  }

  resetValue(product_group_id, main_product_index) {
    this.by_product_dict[product_group_id][main_product_index]['is_checked'] = false;
    this.by_product_dict[product_group_id][main_product_index]['expiry_date'] = null;
    this.by_product_dict[product_group_id][main_product_index]['new_quantity'] = null;
    this.by_product_dict[product_group_id][main_product_index]['price_per_unit'] = null;
    this.by_product_dict[product_group_id][main_product_index]['price'] = null;
    this.by_product_dict[product_group_id][main_product_index]['igst_value'] = null;
    this.by_product_dict[product_group_id][main_product_index]['sgst_value'] = null;
    this.by_product_dict[product_group_id][main_product_index]['cgst_value'] = null;
    this.by_product_dict[product_group_id][main_product_index]['total_price'] = null;
  }


  removeCalled(product_index) {
    let product_group_id = this.selected_product_list[product_index]["product_group"];
    let product_list = this.by_product_dict[product_group_id];
    let main_product_index = product_list
      .map((element) => {
        return element.id;
      })
      .indexOf(this.selected_product_list[product_index]['id']);

    this.selected_product_list.splice(product_index, 1);
    this.resetValue(product_group_id, main_product_index);
  }

  checkSGSTCGSTDisable(product_index) {
    let processing_product = this.selected_product_list[product_index];
    if (processing_product['igst_value'] == null) {
      return false;
    } else {
      return true;
    }
  }


  checkIGSTDiable(product_index) {
    let processing_product = this.selected_product_list[product_index];
    if (processing_product['sgst_value'] == null && processing_product['cgst_value'] == null) {
      return false;
    } else {
      return true;
    }
  }

  changeProductToValid(product_index) {
    console.log('chnaged detedted');
    let processing_product = this.selected_product_list[product_index];
    this.selected_product_list[product_index]['is_valid'] = true;
    if (processing_product['new_quantity'] <= 0 || processing_product['new_quantity'] == null || processing_product['price_per_unit'] == null || processing_product['price'] == null) {
      this.selected_product_list[product_index]['is_valid'] = false;
    } else {
      if (processing_product['sgst_value'] == null && processing_product['cgst_value'] == null && processing_product['igst_value'] == null) {
        this.selected_product_list[product_index]['is_valid'] = false;
      } else {
        if (processing_product['igst_value'] == null && (processing_product['sgst_value'] == null || processing_product['cgst_value'] == null)) {
          this.selected_product_list[product_index]['is_valid'] = false;
        }
      }
    }
    this.selected_product_list[product_index]['total_price'] = 0;
    this.selected_product_list[product_index]['default_sgst_value'] = (processing_product['sgst_percent'] / 100) * processing_product['price']
    this.selected_product_list[product_index]['default_cgst_value'] = (processing_product['cgst_percent'] / 100) * processing_product['price']

    let total_amount = processing_product['price'] + processing_product['sgst_value'] + processing_product['cgst_value'] + processing_product['igst_value'];
    // let igst_value = processing_product['sgst_value'] + processing_product['cgst_value'];
    this.selected_product_list[product_index]['price_per_unit'] = total_amount / processing_product['new_quantity'];
    this.selected_product_list[product_index]['total_price'] = total_amount;
    // this.selected_product_list[product_index]['igst_value'] = igst_value;
    console.log(processing_product);
  }

  checkValidForUpdate() {
    if (this.bill_date !== null && this.bill_number !== null) {
      return false;
    } else {
      return true;
    }
  }

  updateCalled() {
    let is_valid = true;
    this.selected_product_list.forEach(element => {
      if (!element['is_valid']) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      alert('The Product list is Not valid');
      return false;
    }
    let data_dict = {
      'grn_number': this.grn_number,
      'source': this.source,
      'grn_date': this.grn_date,
      'bill_number': this.bill_number,
      'bill_date': this.bill_date,
      'po_number': this.po_number,
      'po_date': this.po_date,
      'dc_date': this.dc_date,
      'dc_number': this.dc_number,
      'selected_product_list': this.selected_product_list
    }
    console.log(data_dict);
    this.httpService.createInputStockRecord(data_dict).subscribe((data) => {
      console.log(data);
      this.grn_number = null;
      this.bill_number = null;
      this.bill_date = null;
      this.grn_date = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0];
      this.po_date = null;
      this.po_number = null;
      this.dc_date = null;
      this.dc_number = null;
      this.source = null;
      this.selected_product_list = [];
      this.serveProductList();
      this.show_grn_table = false;
    }, (error) => {
      console.error(error);
    });
  }

  enableProductGoods() {
    this.show_product_goods_table = false;
  }

  serveGoodsRecord(produt) {
    this.selected_product_name = produt['short_name']
    let data_dict = {
      'product_id': produt['id']
    }
    this.httpService.serveGoodsRecordForProduct(data_dict).subscribe(
      (data: any) => {
        console.log(data);
        this.product_goods_record = data;
        this.show_product_goods_table = true;
        window.scrollTo(0, 0);
      },
      (error) => {
        console.error(error);
      }
    );
  }


  ngOnInit() { }

  checkAndBackToOldGrnNumber() {
    this.httpService.updateGRNNumber().subscribe(
      (data) => {
        console.log(data);
        this.grn_number = data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngOnDestroy() {
    this.httpService.updateGRNNumber().subscribe(
      (data) => {
        console.log(data);
        this.grn_number = data;
      },
      (error) => {
        console.error(error);
      }
    );
    console.log("leaving");
  }
}
